// Owns the workspace's journey/navigation presentation. Existing controls and their
// working values move with the visitor journey; persistence stays in the host editor.
export function mountConversationWorkspace(root, { onStage, shopify = false }) {
  const conversation = root.querySelector('section[data-tab="flow"]');
  const questions = root.querySelector('#mag-flow-panel');
  const welcome = root.querySelector('section[data-tab="welcome"]');
  const finish = root.querySelector('section[data-tab="finish"]');
  let current = 'flow';
  const stages = { welcome, flow: questions, finish };
  for (const [key, panel] of Object.entries(stages)) {
    panel.classList.remove('mag-tab');
    delete panel.dataset.tab;
    panel.dataset.journeyPanel = key;
  }
  const heading = document.createElement('div');
  heading.className = 'mag-journey-heading';
  heading.innerHTML = '<h2>Your conversation</h2>';
  heading.hidden = shopify;
  const nav = document.createElement('nav'); nav.className = 'mag-journey-nav'; nav.setAttribute('aria-label', 'Conversation stages');
  nav.innerHTML = '<button type="button" data-journey="welcome"><span>Welcome</span></button><button type="button" data-journey="flow"><span>Questions</span></button><button type="button" data-journey="finish"><span>Finish</span></button>';
  let extraScreens;
  if (shopify) {
    nav.classList.add('mag-journey-nav--shopify');nav.setAttribute('aria-label','Product guide screens');
    const main = nav.querySelector('[data-journey="flow"]');main.querySelector('span').textContent='Product guide';
    extraScreens=document.createElement('details');extraScreens.className='mag-guide-extra-screens';
    const label=document.createElement('summary');label.textContent='Additional screens';extraScreens.append(label);
    for(const [key,text] of [['welcome','Welcome screen'],['finish','After submission']]) {
      const button=nav.querySelector(`[data-journey="${key}"]`);button.querySelector('span').textContent=text;extraScreens.append(button);
    }
    nav.replaceChildren(main,extraScreens);
  }
  conversation.replaceChildren(heading, nav, welcome, questions, finish);
  nav.addEventListener('click', event => {
    const button = event.target.closest('[data-journey]');
    if (button) onStage(button.dataset.journey);
  });
  for (const key of ['welcome', 'finish']) root.querySelector(`.mag-modal__navitem[data-tab="${key}"]`).remove();
  const experiment = root.querySelector('.mag-modal__navitem[data-tab="ab"]');
  const more = document.createElement('details'); more.className = 'mag-editor-more';
  const summary = document.createElement('summary'); more.append(summary, experiment);
  root.querySelector('.mag-modal__nav').append(more);
  const refreshExperiment = () => { summary.textContent = root.querySelector('#mag-f-ab').checked ? 'More settings · A/B active' : 'More settings'; };
  root.querySelector('#mag-f-ab').addEventListener('change', refreshExperiment); refreshExperiment();

  const copy = {
    'mag-f-name': 'Internal name', 'mag-f-title': 'Visitor-facing title', 'mag-f-launcher': 'Floating button text',
    'mag-f-domains': 'Website domains', 'mag-f-home': 'Start with a welcome and visitor options',
    'mag-f-summary': 'Let visitors review their answers before sending', 'mag-f-summary-heading': 'Review heading',
    'mag-f-summary-confirm': 'Send button text', 'mag-f-success-title': 'Confirmation heading',
    'mag-f-success-text': 'Confirmation message', 'mag-f-success-cta-label': 'Follow-up button text (optional)',
    'mag-f-success-cta-url': 'Follow-up link',
  };
  for (const [id, text] of Object.entries(copy)) {
    const label = root.querySelector(`label[for="${id}"]`); if (label) label.textContent = text;
  }
  root.querySelector('[role="radiogroup"][aria-label="mag-theme"]')?.setAttribute('aria-label', 'Theme');
  root.querySelector('#mag-logo-browse')?.setAttribute('aria-label', 'Choose logo image');
  const display = root.querySelector('[role="radiogroup"][aria-label="mag-display"]');
  if (display) {
    display.setAttribute('aria-label', 'How it appears on your website');
    display.previousElementSibling.textContent = 'How it appears on your website';
    const names = { inline: 'Embedded on page', chat: 'Chat bubble', right_slide: 'Slide-in panel', modal: 'Pop-up' };
    for (const input of display.querySelectorAll('input')) input.nextElementSibling.lastChild.textContent = names[input.value];
    display.nextElementSibling.textContent = shopify ? 'Add the Mach Five Magnet Inline conversation block in your Shopify theme.' : 'An embedded magnet sits inside your page. The other options open over your website.';
  }
  const descriptions = { book: 'Offer appointment requests or booking through a connected calendar.', chat: 'Start your main conversation.', call: 'Open a phone call.', email: 'Open an email draft.', support: 'Ask which team can help.' };
  for (const row of welcome.querySelectorAll('.mag-cta')) {
    const main = row.querySelector('.mag-cta__main');
    const toggle = row.querySelector('.mag-cta__on');
    const fields = document.createElement('div'); fields.className = 'mag-visitor-option-fields';
    fields.append(...[...main.children].filter(child => !child.classList.contains('mag-cta__tog')));
    const options = row.querySelector('.mag-cta__opts'); if (options) fields.append(options);
    fields.querySelector('.mag-cta__note')?.remove();
    const description = document.createElement('p'); description.className = 'mag-visitor-description'; description.textContent = descriptions[row.dataset.type];
    row.append(description, fields);
    const update = () => { fields.hidden = !toggle.checked; };
    toggle.addEventListener('change', update); update();
    for (const [selector, label] of Object.entries({
      '.mag-cta__booksrc': 'How visitors schedule', '.mag-cta__calevent': 'Calendly event', '.mag-cta__ccevent': 'Cal.com event',
      '.mag-cta__mbevent': 'Microsoft Bookings page', '.mag-cta__mbservice': 'Microsoft Bookings service',
      '.mag-cta__callsrc': 'Phone number source', '.mag-cta__crtracker': 'CallRail number', '.mag-cta__opts': 'Support choices, one per line',
      '.mag-cta__val': { book: 'Meeting label or booking link', call: 'Phone number', email: 'Email address' }[row.dataset.type],
    })) {
      const input = fields.querySelector(selector); if (input && label) input.setAttribute('aria-label', label);
    }
    const builtin = fields.querySelector('.mag-cta__booksrc option[value=""]'); if (builtin) builtin.textContent = 'Appointment request';
    if (row.dataset.type === 'book') {
      const source = fields.querySelector('.mag-cta__booksrc');
      const help = document.createElement('p'); help.className = 'mag-modal__hint';
      help.id = 'mag-booking-method-help'; source.after(help);
      source.setAttribute('aria-describedby', help.id);
      const explain = () => {
        const provider = { calendly: 'Calendly', calcom: 'Cal.com', ms_bookings: 'Microsoft Bookings' }[source.value];
        help.textContent = provider
          ? `Choose the ${provider} event or booking page visitors should use. Availability and confirmation follow its booking settings.`
          : 'Visitors suggest a time for your team to confirm. To let them book directly, select a calendar provider or paste a booking link.';
      };
      source.addEventListener('change', explain); explain();
    }
  }
  const welcomeSections = welcome.querySelectorAll('.mag-modal__sec');
  welcomeSections[1].querySelector('.mag-modal__sec-t').textContent = 'Visitor options';
  welcomeSections[1].querySelector('.mag-modal__hint').textContent = 'Choose how people can contact you. Each enabled option appears in the magnet. Turn one off to hide it; its conversation is kept.';
  finish.querySelectorAll('.mag-modal__sec-t')[0].textContent = 'Before sending';
  finish.querySelectorAll('.mag-modal__sec-t')[1].textContent = 'After answers are sent';
  let finishState = 'success';
  const finishPanels = [...finish.querySelectorAll('.mag-modal__sec')];
  const finishNav = document.createElement('nav');
  finishNav.className = 'mag-journey-nav';
  finishNav.setAttribute('aria-label', 'Finish screens');
  finishNav.innerHTML = '<button type="button" data-finish="review">Review answers</button><button type="button" data-finish="success">Confirmation</button>';
  finish.prepend(finishNav);
  const showFinish = state => {
    if (!['review', 'success'].includes(state)) return;
    finishState = state;
    finishPanels[0].hidden = state !== 'review';
    finishPanels[1].hidden = state !== 'success';
    for (const button of finishNav.querySelectorAll('button')) button.setAttribute('aria-pressed', String(button.dataset.finish === state));
  };
  finishNav.addEventListener('click', event => {
    const button = event.target.closest('[data-finish]');
    if (button) { showFinish(button.dataset.finish); onStage('finish'); }
  });
  showFinish(finishState);
  const homeNote = welcome.querySelector('#mag-f-welcome').nextElementSibling;
  const updateHomeNote = () => { homeNote.textContent = root.querySelector('#mag-f-home').checked
    ? 'Visitors see this welcome when at least one visitor option is enabled.'
    : 'Visitors start with your questions. This welcome text is kept for later.'; };
  root.querySelector('#mag-f-home').addEventListener('change', updateHomeNote); updateHomeNote();

  return {
    show(name) {
      if (Object.hasOwn(stages, name)) {
        current = name;
        if(extraScreens)extraScreens.open = name !== 'flow';
        for (const [key, panel] of Object.entries(stages)) panel.hidden = key !== name;
        for (const button of nav.querySelectorAll('button')) {
          if (button.dataset.journey === name) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        }
        return 'flow';
      }
      if (name === 'ab') more.open = true;
      return name;
    },
    stage: () => current,
    finishState: () => finishState,
    showFinish,
  };
}
